export const ORDER_STATUSES_LABELS = {
  // CHECKOUT
  PENDING: 'En attente',
  // PAYMENT
  AWAITING_PAYMENT: 'En attente paiement',
  DISPUTED: 'Contesté',
  PAYMENT_FAILED: 'Paiement refusé',
  // ORDER IS SENT TO SHOP
  AWAITING_FULFILLMENT: 'À traiter',

  // ORDER VALIDATION / INVALIDATION
  CANCELLED: 'Annulée',
  ACCEPTED: 'Acceptée',
  REJECTED: 'Refusée',
  // ORDER PREPARATION / DELIVERY
  AWAITING_PACKING: 'À emballer',
  AWAITING_PICKUP: 'À livrer',
  // FINAL STATUSES
  COMPLETED: 'Finalisée',
  REFUNDED: 'Remboursée',
};

export const ORDER_STATUSES_CHIP_COLORS = {
  // CHECKOUT
  PENDING: undefined,
  // PAYMENT
  AWAITING_PAYMENT: undefined,
  DISPUTED: 'error',
  PAYMENT_FAILED: 'error',
  // ORDER IS SENT TO SHOP
  AWAITING_FULFILLMENT: 'secondary',

  // ORDER VALIDATION / INVALIDATION
  CANCELLED: 'tertiary',
  ACCEPTED: undefined,
  REJECTED: 'tertiary',
  // ORDER PREPARATION / DELIVERY
  AWAITING_PACKING: 'secondary',
  AWAITING_PICKUP: 'secondary',
  // FINAL STATUSES
  COMPLETED: 'success',
  REFUNDED: undefined,
};

export enum ORDER_STATUS_ENUM {
  // CHECKOUT
  PENDING = 'PENDING',
  // PAYMENT
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  DISPUTED = 'DISPUTED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  // ORDER IS SENT TO SHOP
  AWAITING_FULFILLMENT = 'AWAITING_FULFILLMENT',

  // ORDER VALIDATION / INVALIDATION
  CANCELLED = 'CANCELLED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  // ORDER PREPARATION / DELIVERY
  AWAITING_PACKING = 'AWAITING_PACKING',
  AWAITING_PICKUP = 'AWAITING_PICKUP',
  // FINAL STATUSES
  COMPLETED = 'COMPLETED',
  REFUNDED = 'REFUNDED',
}
